import React from "react";

function MandatoryIconField() {
    return (
        <span style={{ color: 'red', fontSize: '20px', textAlign: 'center', marginLeft: '2px', height: '10px' }}>*</span>
    )
}

export default MandatoryIconField;
